import interceptorAxios from './InterceptorAxios';

const ServicioIngresosDiversos={
    
  obtner_comprobante(objeto){
      return interceptorAxios.post('/diversos/optener_comprobante_diversos.json',objeto);
  },
  realizar_calculos_cantidad_total(objeto){
      return interceptorAxios.post('/diversos/realizar_calculos_cantidad_total.json',objeto);
  },
  facturar_comprobante(objeto){
    return interceptorAxios.post('/diversos/facturacion_ingresos_diversos.json',objeto);
}
}
export default ServicioIngresosDiversos;